import { Flex, SimpleGrid } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";
import utils from "utils";

function PaymentsReceivedView() {
  const [isLoading, setIsLoading] = useState(false);

  const [dealers, setDealers] = useState();
  const [dealerid, setDealerId] = useState();

  const [datepayment, setDatepayment] = useState();
  const [paymentamount, setPaymentamount] = useState();
  const [comment, setComment] = useState();
  const [paymentnumber, setPaymentnumber] = useState();
  const [paymentid, setPaymentid] = useState();
  // const [receivedbyoperator, setReceivedbyoperator] = useState();

  const navigate = useNavigate();
  const location = useLocation();

  const action = location.state?.action;
  const itemData = location.state?.data;

  const onNew = async () => {
    if (!dealerid) {
      toaster.create({
        title: "Please select dealer",
        type: "error",
      });
      return;
    }

    if (!datepayment) {
      toaster.create({
        title: "Please select datepayment",
        type: "error",
      });
      return;
    }

    setIsLoading(true);
    return api
      .addPaymentsin({
        datepayment: datepayment ? utils.dateToDateInput(datepayment) : "",
        dealerid: dealerid,
        paymentamount: parseInt(paymentamount),
        comment: comment,
        paymentnumber: paymentnumber || "",

        // req?.body?.datepayment,
        // req?.body?.dealerid,
        // req?.body?.paymentamount,
        // req?.body?.comment,
        // req?.body?.paymentnumber,
        // req?.body?.receivedbyoperator,
        // [ undefined, '', '222', 'DDD', undefined, undefined ]
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          toaster.create({
            title: res?.message || "success",
            type: "success",
          });
          navigate("/paymentsreceived", {
            state: {},
          });
        } else {
          toaster.create({
            title: res?.message || "error",
            type: "error",
          });
        }
      });
  };

  const onSubmit = async () => {
    if (action === "paymentsreceivedview-add") {
      onNew();
      return;
    }

    if (!paymentid) {
      toaster.create({
        title: "Please select dealer",
        type: "error",
      });
      return;
    }

    if (!dealerid) {
      toaster.create({
        title: "Please select dealer",
        type: "error",
      });
      return;
    }

    if (!datepayment) {
      toaster.create({
        title: "Please select datepayment",
        type: "error",
      });
      return;
    }

    setIsLoading(true);

    return api
      .updatePaymentsin({
        datepayment: datepayment ? utils.dateToDateInput(datepayment) : "",
        dealerid: dealerid,
        paymentamount: parseInt(paymentamount),
        comment: comment,
        paymentnumber: paymentnumber || "",
        paymentid: itemData?.paymentid,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          toaster.create({
            title: res?.message || "success",
            type: "success",
          });
          navigate("/paymentsreceived", {
            state: {},
          });
        } else {
          toaster.create({
            title: res?.message || "error",
            type: "error",
          });
        }
      });
  };

  const onDealersChange = (data) => {
    console.log("onDealersChange", data);
    setDealers(data?.list ? [...data.list] : []);
    setDealerId(data?.item?.data?.dealerid || "");

    // if (data?.action !== "useState") {
    //   if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
    //     getList({
    //       dealerid: data?.item?.data?.dealerid,
    //       action: data?.action,
    //       page: 1,
    //     });
    //   } else {
    //     getList();
    //   }
    // }
  };

  useEffect(() => {
    console.log("itemData", itemData);

    const cb = async () => {
      // await getDealers({ action: "useState" });
      await utils.getDealers({
        setIsLoading,
        action: "useState",
        onDealersChange,
        allOption: false,
        defaultVal: itemData?.dealerid,
      });

      const i = itemData;
      setDatepayment(i?.datepayment || "");
      setPaymentamount(i?.paymentamount || 0);
      setComment(i?.comment || "");
      setPaymentnumber(i?.paymentnumber || "");
      setPaymentid(i?.paymentid || "");
      // setReceivedbyoperator(i?.receivedbyoperator || 0);
    };
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={`${
          action === "paymentsreceivedview-edit"
            ? "Payments Received - " + itemData?.paymentnumber
            : "New Payments Received"
        }`}
        isLoading={isLoading}
      />

      <Layout>
        <SimpleGrid columns={1} columnGap="1rem" rowGap="1rem">
          <InputComp
            type={"date"}
            label={"Date Payed"}
            value={datepayment}
            onChange={setDatepayment}
          />

          <InputComp
            label={"Account"}
            type={"dropdown"}
            items={dealers}
            onChange={onDealersChange}
          />
          <InputComp
            label={"Amount"}
            type="number"
            value={paymentamount}
            onChange={setPaymentamount}
            // keyname={"amount"}
          />
          <InputComp
            type={"textarea"}
            label={"Comment"}
            value={comment}
            onChange={setComment}
            keyname={"w-100"}
          />
        </SimpleGrid>
      </Layout>

      <Flex flexFlow={"wrap"} justify={"end"} gap={"0.5rem"} mt={"1rem"}>
        <ButtonComp
          label={action === "paymentsreceivedview-edit" ? "Save" : "Add"}
          keyname="submit"
          onClick={onSubmit}
          disabled={isLoading}
        />
      </Flex>
    </Flex>
  );
}

export default PaymentsReceivedView;
